export default __webpack_public_path__ + "static/media/www_author.06155f9d.svg";